import queryString from 'query-string'
import { sizeRatioMap } from 'lemon-campaign-ui/lib/hoc/resize'

const placeholderImgix = (url, size) => {
  if (!url || !size) {
    return
  }

  const index = url.indexOf('?')
  if (index === -1) {
    url = `${url}?`
  }

  const [baseUrl, query] = url.split('?')

  const queryObj = queryString.parse(query)
  if (queryObj) {
    queryObj.w = 100

    if (sizeRatioMap[size]) {
      queryObj.h = (queryObj.w / sizeRatioMap[size]) * 2
    }

    queryObj.auto = 'compress'
    queryObj.fm = 'webp'
    queryObj.q = 0
    queryObj.blur = 100
  }

  return `${baseUrl}?${queryString.stringify(queryObj)}`
}

export default placeholderImgix
